import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import ProcessField from 'components/core/fields/ProcessField';
import ProcessUtils from 'utils/ProcessUtils';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import RIEInput from 'components/core/editable/RIEInput';

/**
 * Base class for process form field components that can be reused throughout the PCM.
 */
export default class OutputDatastreamNameField extends ProcessField {

    static propTypes = Object.assign({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        dods: PropTypes.array,
        dodOnTheFlyOnly: PropTypes.bool,
        navigateOnRename: PropTypes.bool
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
        dodOnTheFlyOnly: false,
        navigateOnRename: true
    }, ProcessField.defaultProps);

    onNameChanged = (fieldPath, value) => {
        let newName = null;
        if (typeof value === 'string') {
            newName = value;
        } else {
            newName = value.value;
        }
        const editor = ProcessUtils.getEditor(this.props.process);
        editor.renameOutputDatastream(this.props.value, newName, this.props.navigateOnRename);
        editor.commit();
    };

    render() {
        const valueObj = { value: this.props.value, label: this.props.value };
        const outputDatastreamOptions = this.props.dods.map((datastream) => {
            return { value: datastream, label: datastream };
        });
        const checkUnique = {
            label: 'output datastream',
            list: Object.keys(this.props.process.output_datastreams)
        };
        const fieldPath = ['output_datastreams', this.props.value];
        let inputComponent = null;
        if (this.props.dodOnTheFlyOnly) {
            inputComponent = (
                <RIEInput
                    value={this.props.value}
                    change={this.onNameChanged}
                    fieldPath={fieldPath}
                    isDisabled={!this.props.hasWritePermissions}
                    processId={this.props.process.name}
                    processErrors={this.props.processErrors}
                    urlCommit
                    checkUnique={{ list: this.props.dods, label: 'output datastream' }}
                    formDisplay={this.props.forceFormDisplay}
                />
            );
        } else {
            inputComponent = (
                <RIEComboBox
                    value={valueObj}
                    options={outputDatastreamOptions}
                    fieldPath={fieldPath}
                    change={this.onNameChanged}
                    isDisabled={!this.props.hasWritePermissions}
                    multi={false}
                    creatable
                    urlCommit
                    checkUnique={checkUnique}
                    processId={this.props.process.name}
                    processErrors={this.props.processErrors}
                    formDisplay={this.props.forceFormDisplay}
                />
            );
        }
        return (
            <Flexbox className={this.props.className} flexDirection="row" alignItems="flex-start">
                <InfoBoxLabel label="Output Datastream Name"/>
                {inputComponent}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/OutputDatastreamNameField.js